export class SubmitSectionResponseDto {
  userAssessmentDriveSetId?: string;
  sectionDto?: SubmitSectionDto;
  ipAddress?: string;
  location?: string;
  countOfWebFeedChunks?: number;
  countOfScreeShareChunks?: number;
}

export class SubmitSectionDto {
  sectionQuestionList?: SectionQuestionDto[] = [];
  sectionStatus?: string;
  sequence?: number;
}

export class SectionQuestionDto {
  mquestionId?: string;
  mQuestionId?: string;
  selectedOptionsIds?: string[] = [];
  sectionQuestionId?: string;
  // singleWordAnswer?: string;
  sequence?: number;
  responseFileId?: string;
  questionId?: string;
  timeTakenInSeconds?: number;
  singleWordAnswer?: string;
  fibAnswer?: any = {};
  multipleFibAns?: any = {};
  booleanTypeResponse?: boolean;
  sourceCode?: string;
  candidateTestCaseDtos?: any[];
  languageId?: string;
  newAudioQuestion?: string;
  languageName?: any;
  backendTestcases?:any;
  frontendTestcases?: any;
  correctOption?: string;
  languageType?: string;
}

export class SubCategoryResponseDto {
  sectionQuestionDtos?: SectionQuestionDto[] = [];
  sequence?: number;
  id?: string;
}
export class ProgressiveResponseDto {
  id: string;
  name?: string;
  subCategories?: SubCategoryResponseDto[] = [];
  sectionTimeInMins?: number;
  sequence?: number;
  totalSectionScore?: number;
  sectionStatus?: string;
  driveId?: string;
  nextSectionSequence?: number;
  countOfWebFeedChunks?: number;
  countOfScreeShareChunks?: number;
}

export class SubCategoryDetailsDto {
  sectionSequence?: number;
  driveConfigId?: string;
}

export class ProgressivePayloadDtoForDumpApi {
  userAssessmentDriveSetId?: string;
  sectionDto: SubmitSectionDto = new SubmitSectionDto(); 
  ipAddress?: string;
  location?: string;
  countOfWebFeedChunks?: number;
  countOfScreeShareChunks?: number;
}